import { render } from "./ImportFileStatGov.vue?vue&type=template&id=fc3f8bde&scoped=true&ts=true"
import script from "./ImportFileStatGov.vue?vue&type=script&lang=ts"
export * from "./ImportFileStatGov.vue?vue&type=script&lang=ts"

import "./ImportFileStatGov.vue?vue&type=style&index=0&id=fc3f8bde&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3f8bde"]])

export default __exports__